export default __webpack_public_path__ + "static/media/regulatory--turn-left--g2.01af6a90.png";